import { Tooltip, Typography } from "@mui/material";
import { formatCurrency } from "@/utils/format-currency";

const formatDate = (value) => {
  if (!value) return "N/A";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
};

export const getLedgerEntryColumns = () => [
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.createdAt)}
      </div>
    ),
  },
  {
    accessorKey: "journalReference",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Reference</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.8rem" fontFamily="monospace">
        {row.original.journalReference ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "narration",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Narration</div>,
    // Narrations can be very long (e.g. payout-service error dumps). Clamp to a
    // single ellipsised line; the full text is available on hover via the tooltip.
    cell: ({ row }) => {
      const narration = row.original.narration;
      if (!narration) {
        return <div style={{ fontSize: "0.82rem", color: "#374151" }}>—</div>;
      }
      return (
        <Tooltip title={narration} placement="top-start" arrow>
          <div
            style={{
              fontSize: "0.82rem",
              color: "#374151",
              maxWidth: 280,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {narration}
          </div>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "amount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Amount</div>,
    cell: ({ row }) => {
      const isDebit = row.original.entryType === "DEBIT";
      const sign = isDebit ? "-" : "+";
      return (
        <Typography
          fontSize="0.85rem"
          fontWeight={600}
          sx={{ color: isDebit ? "#b91c1c" : "#047857", whiteSpace: "nowrap" }}
        >
          {sign}
          {formatCurrency(
            row.original.amount ?? 0,
            row.original.currency ?? "NGN",
          )}
        </Typography>
      );
    },
  },
  {
    accessorKey: "balanceAfter",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Balance After</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.balanceAfter != null
          ? formatCurrency(
              row.original.balanceAfter,
              row.original.currency ?? "NGN",
            )
          : "N/A"}
      </Typography>
    ),
  },
];
